module.exports = __webpack_public_path__ + "static/media/image-1200.d4fd2fe3.webp";